




import Vue from 'vue'
export default Vue.extend({
  name: 'InputIpDemo',
  props: [],
  data() {
    return {
      
    }
  },
  watch: {
  },
  methods: {
    onChange(v){
      console.log('ip change:', v);
    }
  }
})
